import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { SubmitButton } from "school-admin/Login/styles";
import { TextInput, PasswordInput, FieldWrap } from "share/atoms/form-fields";
import {
  EmpoyeeIdForm,
  ErrorText,
  NHeader,
  NLabel,
  NWelcomText,
} from "./styles";
import { ScreenWrapper } from "./styles";
import { employErrorReset } from "./actions";

function EmployeeIDScreen({ handleSubmit, error }) {
  const dispatch = useDispatch();
  const [empId, setEmpId] = useState("");

  useEffect(() => {
    return () => dispatch(employErrorReset());
  }, []);

  const handleIntegerChange = (e) => {
    const value = e.target.value;
    const alphaNumericRegex = /^[a-zA-Z0-9]*$/;
    if (alphaNumericRegex.test(value) || value === "") {
      setEmpId(value);
      dispatch(employErrorReset());
    }
  };
  return (
    <ScreenWrapper>
      <NWelcomText>
        Welcome! <br />
        Login to your account
      </NWelcomText>
      <EmpoyeeIdForm
        onSubmit={(e) => handleSubmit(e, empId)}
        autoComplete="off"
      >
        <FieldWrap>
          <NLabel htmlFor="userId">Narayana Global ID</NLabel>
          <TextInput
            id="userId"
            name="userId"
            type="text"
            autoComplete="off"
            autoFocus={false}
            placeholder="Enter your global ID"
            value={empId}
            onChange={handleIntegerChange}
            error={error}
          />
          {error && <ErrorText>{error}</ErrorText>}
        </FieldWrap>

        <SubmitButton
          type="submit"
          disabled={empId === ""}
          style={{ width: "100%" }}
        >
          Proceed
        </SubmitButton>
      </EmpoyeeIdForm>
    </ScreenWrapper>
  );
}

export default EmployeeIDScreen;
